import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const START_AB_TEST: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation startAbTest($input: StartAbTestInput!) {
    startAbTest(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
